import React from 'react';
import { useSelector } from 'react-redux';
import { hasScheduledSocialPostAccessSelector } from 'redux/modules/pricing';
import { useSocialShareModal } from '../SocialShareModalContext';
import useSocialPostShareStatus from '../SocialSharePlatforms/useSocialPostShareStatus';
import GatedScheduleButton from './GatedScheduleButton';
import ScheduleDateButton from './ScheduleDateButton';

export type ScheduleButtonProps = {
  isDisabled?: boolean;
};

const ScheduleButton: React.FC<ScheduleButtonProps> = ({ isDisabled }) => {
  const { isSchedulingPost } = useSocialShareModal();
  const { isSharingPost } = useSocialPostShareStatus();

  const hasScheduledSocialPostAccess = useSelector(
    hasScheduledSocialPostAccessSelector,
  );

  if (isSchedulingPost || isSharingPost) {
    return null;
  }

  return !hasScheduledSocialPostAccess ? (
    <GatedScheduleButton />
  ) : (
    <ScheduleDateButton isDisabled={isDisabled} />
  );
};

export default ScheduleButton;
